/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import './custom/slick-slider.js';
import './custom/about.js';
import './custom/contact.js';
import './custom/forms.js';
import './custom/world-map-popper.js';
import './custom/timeline-slider.js';
import './custom/more-sliders.js';
import HeaderAnimation from './custom/Headroomanimation';

// const fontloader = new Fontloader()
const headerAnimation = new HeaderAnimation

$(document).ready(() => {
  headerAnimation.events()

  //for
  // const $dropdown = $(".dropdown");
  // const $dropdownToggle = $(".dropdown-toggle");
  // const $dropdownMenu = $(".dropdown-menu");
  // const showClass = "show";

  // $(window).on("load resize", function() {
  //   if (this.matchMedia("(min-width: 768px)").matches) {
  //     $dropdown.hover(
  //       function() {
  //         const $this = $(this);
  //         $this.addClass(showClass);
  //         $this.find($dropdownToggle).attr("aria-expanded", "true");
  //         $this.find($dropdownMenu).addClass(showClass);
  //       },
  //       function() {
  //         const $this = $(this);
  //         $this.removeClass(showClass);
  //         $this.find($dropdownToggle).attr("aria-expanded", "false");
  //         $this.find($dropdownMenu).removeClass(showClass);
  //       }
  //     );
  //   } else {
  //     $dropdown.off("mouseenter mouseleave");
  //   }
  // });
});
